import { defaultHttpClient } from '../../httpClient';
import type { GetMumulLiveCurrentCampaignResponse } from './types';

/**
 * - 무물라이브 프로필의 현재 캠페인 조회 API
 */
export const getMumulLiveCurrentCampaign = (profileSno: number) => {
  return defaultHttpClient
    .request<GetMumulLiveCurrentCampaignResponse>({
      method: 'GET',
      url: `/webview/mumul-live/profiles/${profileSno}/current-campaign/`,
    })
    .then(r => r.data);
};
